import { Logger } from "@suse-o11y/logger";
import { EMPTY, catchError, flatMap, from, map, of } from "@suse-o11y/rxjs";
import isError from "lodash/isError";
import type { AnyAction } from "redux";
import { type Epic, ofType } from "redux-observable";

import { upgrade } from "../../../../backend/StackPacksApi";
import type { EpicDependencies } from "../../ReduxStore";
import type { RootState } from "../../RootState";

import {
	type UpgradeStackPack,
	type UpgradeStackPackError,
	type UpgradeStackPackSuccess,
	upgradeStackPackError,
	upgradeStackPackSuccess,
} from "./StackPacksActions";
import { STACK_PACKS_UPGRADE_START } from "./StackPacksActionTypes";

const logger = Logger.namespace("StackPacksUpgradeEpic");

type ResultActions = UpgradeStackPackSuccess | UpgradeStackPackError;

export const StackPacksUpgradeEpic: Epic<AnyAction, ResultActions, RootState, EpicDependencies> = (actions) =>
	actions.pipe(
		ofType<UpgradeStackPack>(STACK_PACKS_UPGRADE_START),
		flatMap(({ stackPack, flag }) =>
			from(upgrade(stackPack.name, flag)).pipe(
				map(() => upgradeStackPackSuccess(stackPack)),
				catchError((error: unknown) => {
					if (!isError(error)) {
						return EMPTY;
					}

					logger.error(error.message);
					return of(upgradeStackPackError(stackPack, error));
				}),
			),
		),
	);
